import React, { useState, useEffect, useContext} from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Button, ButtonGroup, Checkbox, FormControlLabel, FormGroup, Box,} from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import Menu from "../include/menu";
import Footer from "../include/footer";
import Downloadlogo_popup from "./downloadlogo_popup.js";
import VolumeCalculator from "./VolumeCalculator.js";
import CalculatorSection from "./Calculators/Calculatorsection.js";
import PTGC_Burn_Tracker from "./PTGC_Burn_Tracker/BurnTrackerSection";
import PoolInfo from "./Pool_Info/Pool_Info";
import Token_Distribution_Section from "./Token_Distribution/IndexSections";
import ValueGeneration from "./Value_Generation";
import PTGC_Burned_Till_Now from "./PTGC_Burned_Till_Now/PTGC_Burned_Till_Now";
import Projected_Burned from "./Projected_Burned/Projected_Burned";
import PTGC_Growth_Chart from "./PTGC_Growth_Chart/index";
import Volume_metrics from "./Volume_Metrics/index";
import PTGC_volume_PLS_price from "./PTGC_Volume_PLS_Price/index";
import Total_Liquidity_To_Market_Cap_Ratio from "./Total_Liquidity_To_Market_Cap_Ratio/index";
import Rewards from "./Rewards";
import { sendGetRequest } from '../../../Helper/helper'; 
import Context from "../../../context/context";

const IndexSections = () => {
  const {account, onConnect, providers, pTGCVolume, ptgcPrice, ufoPrice, plsPrice} = useContext(Context);
  const [downloadlogo_popupModalOpen, setDownloadlogo_popupModalOpen] = useState(false);
  const openStake = () => setDownloadlogo_popupModalOpen(true);
  const closeDownloadlogo_popupModal = () => setDownloadlogo_popupModalOpen(false);
  const [period, setPeriod] = useState("7d");
  const [visible, setVisible] = useState({volume: true, lp: true, ratio: true,});

  const toggleLine = (key) => (event) => {
    setVisible((prev) => ({ ...prev, [key]: event.target.checked }));
  };
  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,   
    });
  }, []);

  return (
    <>
      <Menu />
      <section className="slideSecInner PTGCSEC StatisticsSec1 slideSec leftrightSecSpace">
        <div className="1 relative">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-7">
              <div className="sliderContent" >
                <h1 className='good_times goldFont' data-aos="fade-up"  data-aos-delay="300" data-aos-duration="600"><img src="./images/logoName.svg"  className="img-fluid logoNameInnerPage m-0"  /><span> Statistics</span></h1>
                <p className="mt-0" data-aos="fade" data-aos-delay="500" data-aos-duration="800"> Access real-time data on token performance, holders, and network activity.</p>
                <div className="bottomSliderBtn"  data-aos="fade-right"  data-aos-delay="700" data-aos-duration="1000">
                  <div className="d-flex gap-3 align-items-center">
                    {
                      account ? 
                      <>
                        <button className="borderbtn mybtn" disabled>
                          <span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid"/>
                        </button>
                      </>
                      :
                      <>
                      <button className="borderbtn mybtn" onClick={onConnect}>
                        <span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid"/>
                      </button>
                      </>
                    }
                    {/*<button onClick={openStake} className="mybtn underline text-white">
                      <span>Download Logos</span>
                    </button>*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 order2"  data-aos="fade-left"  data-aos-delay="700" data-aos-duration="1000">
              <VolumeCalculator 
                volumeDaily={pTGCVolume.volumeDaily} 
                volumeWeekly={pTGCVolume.volumeWeekly} 
                volumeMonthly={pTGCVolume.volumeMonthly} 
                volumeSemiAnnually={pTGCVolume.volumeSemiAnnually} 
                volumeAnnually={pTGCVolume.volumeAnnually} 
              />
            </div>
          </div>
        </div>
      </section>

      <section className="clippathSec PTGCSEC excoSystemSec StatisticsSec5  leftrightSecSpace padsec">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <CalculatorSection 
                volumeDaily={pTGCVolume.volumeDaily} 
                volumeWeekly={pTGCVolume.volumeWeekly} 
                volumeMonthly={pTGCVolume.volumeMonthly} 
                volumeSemiAnnually={pTGCVolume.volumeSemiAnnually} 
                volumeAnnually={pTGCVolume.volumeAnnually} 
                ptgcPrice={ptgcPrice}
              />
            </div>
            <div className="col-lg-8">
              <PTGC_Burn_Tracker volumeDaily={pTGCVolume.volumeDaily} ptgcPrice={ptgcPrice} />
              <div className="row">
                <div className="col-lg-6">
                  <PoolInfo />
                </div>
                <div className="col-lg-6">
                  <Token_Distribution_Section ptgcPrice={ptgcPrice}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ValueGeneration
        volumeDaily={pTGCVolume.volumeDaily} 
        volumeWeekly={pTGCVolume.volumeWeekly} 
        volumeMonthly={pTGCVolume.volumeMonthly} 
        volumeQuarterly={pTGCVolume.volumeQuarterly}
        volumeSemiAnnually={pTGCVolume.volumeSemiAnnually}
        volumeAnnually={pTGCVolume.volumeAnnually} 
      />

      <section className="excoSystemSec StatisticsSec5 padsec leftrightSecSpace">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-6 "   data-aos="fade-right"  data-aos-delay="1000" data-aos-duration="1400">
              <PTGC_Burned_Till_Now 
                volumeDaily={pTGCVolume.volumeDaily} 
                volumeWeekly={pTGCVolume.volumeWeekly} 
                volumeMonthly={pTGCVolume.volumeMonthly} 
                volumeAnnually={pTGCVolume.volumeAnnually}
                ptgcPrice={ptgcPrice} 
              />
            </div>
            <div className="col-sm-6"   data-aos="fade-left"  data-aos-delay="1000" data-aos-duration="1400">
              <Projected_Burned />
            </div>
          </div>
        </div>
      </section>
      <section className="boXSecBottomStats boXSecBottom boXSec padsec pt-0 PTGCSEC">
        <div className="container">
          <div className="w-100">
          <div className="row">
            <div className="col-lg-8">
              <PTGC_Growth_Chart />
            </div>
            <div className="col-lg-4">
              <Volume_metrics />
            </div>
            <div className="col-lg-5">
              <PTGC_volume_PLS_price />
            </div>
            <div className="col-lg-7">
              <Total_Liquidity_To_Market_Cap_Ratio />
            </div>
          </div>
        </div>
        </div>
      </section>
      <Rewards ptgcPrice={ptgcPrice} ufoPrice={ufoPrice} plsPrice={plsPrice}/>
      <Downloadlogo_popup modalIsOpen={downloadlogo_popupModalOpen} closeModal={closeDownloadlogo_popupModal} />
      <Footer />
    </>
  );
};

export default IndexSections;
